<template>
  <v-layout wrap>
    <v-flex
      xs12
      md12
    >
      <v-text-field
        id="management_fee"
        v-model.trim.number="form.management_fee"
        :error-messages="ManagementFeeErrors"
        name="management_fee"
        :label="$t('globals.managementFee')"
        type="number"
        suffix="%"
        required
        @input="$v.form.management_fee.$touch()"
        @blur="$v.form.management_fee.$touch()"
      >
        <template v-slot:append>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">
                mdi-information-outline
              </v-icon>
            </template>
            {{ $t('projects.managementFeeTooltip') }}
          </v-tooltip>
        </template>
      </v-text-field>
    </v-flex>
    <v-flex
      xs12
      md6
    >
      <v-select
        v-model.trim="form.leverage"
        :items="LeverageItems"
        name="leverage"
        :label="$t('globals.leverage')+'*'"
        @change="$v.form.leverage.$touch()"
        @blur="$v.form.leverage.$touch()"
      />
    </v-flex>
    <v-flex
      xs12
      md6
    >
      <v-text-field
        id="drawdown"
        v-model.trim.number="form.drawdown"
        :error-messages="MaxAllowedDrawdownErrors"
        name="drawdown"
        :label="$t('globals.allowedDrawdown')+'*'"
        maxlength="5"
        type="number"
        suffix="%"
        required
        @input="$v.form.drawdown.$touch()"
        @blur="$v.form.drawdown.$touch()"
      >
        <template v-slot:append>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">
                mdi-information-outline
              </v-icon>
            </template>
            {{ $t('projects.drawDownTooltip') }} {{ $t('projects.drawdownHint') }}
          </v-tooltip>
        </template>
      </v-text-field>
    </v-flex>
    <v-flex
      xs12
      md6
    >
      <v-text-field
        id="mindeposit"
        v-model.trim.number="form.mindeposit"
        :error-messages="MinDepositErrors"
        name="mindeposit"
        :label="$t('globals.minDeposit')"
        type="number"
        :suffix="baseCurrency"
        required
        @input="$v.form.mindeposit.$touch()"
        @blur="$v.form.mindeposit.$touch()"
      >
        <template v-slot:append>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">
                mdi-information-outline
              </v-icon>
            </template>
            {{ $t('projects.minDepositTooltip') }}
          </v-tooltip>
        </template>
      </v-text-field>
    </v-flex>

    <v-flex
      xs12
      md6
    >
      <v-text-field
        id="maxdeposit"
        v-model.trim.number="form.maxdeposit"
        :error-messages="MaxDepositErrors"
        name="maxdeposit"
        :label="$t('globals.maxDeposit')"
        type="number"
        :suffix="baseCurrency"
        required
        @input="$v.form.maxdeposit.$touch()"
        @blur="$v.form.maxdeposit.$touch()"
      >
        <template v-slot:append>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">
                mdi-information-outline
              </v-icon>
            </template>
            {{ $t('projects.maxDepositTooltip') }}
          </v-tooltip>
        </template>
      </v-text-field>
    </v-flex>

    <v-flex
      xs12
    >
      <v-text-field
        id="maxinvestors"
        v-model.trim.number="form.maxinvestors"
        :error-messages="MaxInvestorsErrors"
        name="maxdeposit"
        :label="$t('globals.allowedInvestors')"
        type="number"
        required
        @input="$v.form.maxinvestors.$touch()"
        @blur="$v.form.maxinvestors.$touch()"
      >
        <template v-slot:append>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">
                mdi-information-outline
              </v-icon>
            </template>
            {{ $t('projects.allowedInvestorsTooltip') }}
          </v-tooltip>
        </template>
      </v-text-field>
    </v-flex>

    <v-flex
      xs12
      md12
    >
      <v-textarea
        id="project-description"
        v-model.trim="form.description"
        :counter="1000"
        :error-messages="ProjectDescriptionErrors"
        name="project-description"
        :label="$t('globals.description')+'*'"
        :placeholder="$t('projects.descPlaceholder')"
        required
        @input="$v.form.description.$touch()"
        @blur="$v.form.description.$touch()"
      />
    </v-flex>
    <v-flex
      xs12
      md12
    >
      <v-textarea
        id="management"
        v-model.trim="form.management"
        :counter="1000"
        :error-messages="ManagementErrors"
        name="management"
        :label="$t('projects.management')+'*'"
        :placeholder="$t('projects.managementPlaceholder')"
        required
        @input="$v.form.management.$touch()"
        @blur="$v.form.management.$touch()"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  maxLength,
  between
} from "vuelidate/lib/validators";
import { mapMutations, mapGetters } from "vuex";

//const alphanum_specials = value => /^[a-zA-Z0-9()-+-%#$&*/!@:;,._\n'" ]*$/.test(value)

export default {
  name: "FormProfile",
  mixins: [validationMixin],
  props: {
    copyTrading: {
      type: Boolean,
      default: false
    },
    baseCurrency: {
      type: String,
      default: 'BTC'
    },
  },
  data() {
    return {
      LeverageItems: [
        "Cross",
        "1:1",
        "1:2",
        "1:3",
        "1:4",
        "1:5",
        "1:10",
        "1:15",
        "1:20",
        "1:25",
        "1:30",
        "1:40",
        "1:50",
        "1:60",
        "1:70",
        "1:80",
        "1:90",
        "1:100",
        "1:150",
        "1:200",
        "1:300",
        "1:400"
      ],
      form: {
        description: null,
        management: null,
        leverage: "1:1",
        management_fee: 0,
        drawdown: 0,
        mindeposit: 0,
        maxdeposit: 0,
        maxinvestors: 0
      }
    };
  },
  validations() {
    return {
      form: this.rules
    };
  },
  computed: {
    ...mapGetters("project", ["getProject"]),
    rules() {
      var form = {
        description: {
          required,
          minLength: minLength(100),
          maxLength: maxLength(1000)
        },
        management: {
          required,
          minLength: minLength(100),
          maxLength: maxLength(1000)
        },
        leverage: {
          required
        },
        drawdown: {
          required,
          between: between(5, 100)
        },
        management_fee: {
          required
        },
        mindeposit: {
          required
        },
        maxdeposit: {
          required
        },
        maxinvestors: {
          required
        }
      };
      return form;
    },
    ProjectDescriptionErrors() {
      const errors = [];
      if (!this.$v.form.description.$dirty) return errors;
      (!this.$v.form.description.minLength ||
        !this.$v.form.description.maxLength) &&
        errors.push(this.$t("projects.maxDesc"));
      !this.$v.form.description.required &&
        errors.push(this.$t("projects.reqDesc"));
      return errors;
    },
    ManagementErrors() {
      const errors = [];
      if (!this.$v.form.management.$dirty) return errors;
      (!this.$v.form.management.minLength ||
        !this.$v.form.management.maxLength) &&
        errors.push(this.$t("projects.100400Field"));
      !this.$v.form.management.required &&
        errors.push(this.$t("projects.reqField"));
      return errors;
    },
    ManagementFeeErrors(value) {
      const errors = [];
      if (!this.$v.form.management_fee.$dirty) return errors;
      !this.$v.form.management_fee.required &&
        errors.push(this.$t("projects.reqField"));
      return errors;
    },
    MinDepositErrors(value) {
      const errors = [];
      if (!this.$v.form.mindeposit.$dirty) return errors;
      !this.$v.form.mindeposit.required &&
        errors.push(this.$t("projects.reqField"));
      return errors;
    },
    MaxDepositErrors(value) {
      const errors = [];
      if (!this.$v.form.maxdeposit.$dirty) return errors;
      !this.$v.form.maxdeposit.required &&
        errors.push(this.$t("projects.reqField"));
      return errors;
    },
    MaxInvestorsErrors(value) {
      const errors = [];
      if (!this.$v.form.maxinvestors.$dirty) return errors;
      !this.$v.form.maxinvestors.required &&
        errors.push(this.$t("projects.reqField"));
      return errors;
    },
    MaxAllowedDrawdownErrors(value) {
      const errors = [];
      if (!this.$v.form.drawdown.$dirty) return errors;
      !this.$v.form.drawdown.required &&
        errors.push(this.$t("projects.reqField"));
      !this.$v.form.drawdown.between &&
        errors.push(this.$t("projects.530Field"));
      return errors;
    }
  },
  mounted() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type == "project/setProject") {
        this.form = state.project.form;
      }
    });
  },
  methods: {
    ...mapMutations("project", ["saveDescription", "setTab"]),
    save() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.saveDescription(this.form);
      }
    },
  }
};
</script>

<style>
</style>
